import Vue from 'vue'

/**
 *获取门禁记录列表
 */
export const getAccRecordList = params => {
  return Vue.fetch.post('/apiv1/acc/findAccTransactionLogListByPage ', params)
}
/**
 *获取核验记录列表
 */
export const getCheckRecordList = params => {
  return Vue.fetch.post(
    '/apiv1/icc/iccRecord/iccVerifyRecordListByPage',
    params
  )
}

/**
 *获取人证记录列表
 */
export const getPersonRecordList = params => {
  return Vue.fetch.post(
    '/apiv1/icc/iccRecord/iccPersonVerifyRecordListByPage',
    params
  )
}
/**
 *考勤记录列表分页
 * @param {*} params
 */
export const findAttRecordListByPage = params => {
  return Vue.fetch.post('/apiv1/hr/attrecord/findAttRecordListByPage', params)
}



// WEBPACK FOOTER //
// ./src/services/attendanceApi.js